import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const transactionList = createAsyncThunk(
  "transactionList/transactionList",
  async (payload, thunkAPI) => {
    try {
      const response = await api.post("transaction/getall", payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  }
);

const transactionListSlice = createSlice({
  name: "transactionList",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(transactionList.pending, (state) => {
        state.loading = true;
      })
      .addCase(transactionList.fulfilled, (state, action) => {
          
          
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(transactionList.rejected, (state, action) => {
        
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default transactionListSlice.reducer;
